import styled from 'styled-components';

export const StyledTD = styled.td`
    button{
        background-color:transparent;
        min-height:2rem;
        min-width:2rem;
        opacity:0;
        svg{
            width:2rem;
            height:2rem;
        }
        + button{
          margin-left:1.2rem;
        }
    }
`;
